<template lang="pug">
div
  .landing(:class="{ 'cny': cnyMode }")
    #xmas-rain1
    #xmas-rain2
    #cny-rain1
    #cny-rain2
    
    header.header
      .lp-container.d-flex.justify-content-between.align-items-center
        .logo
          img.img-fluid(
            v-if="cnyMode" 
            :src="logoCNYPath"
            :alt="$t('ui.logo')"
          )
          img.img-fluid(
            v-else-if="xmasMode" 
            :src="logoXMASPath"
            :alt="$t('ui.logo')"
          )
          img.img-fluid(
            v-else-if="wcMode" 
            :src="logoWCPath"
            :alt="$t('ui.logo')"
          )
          img.img-fluid(
            v-else 
            :src="logoPath"
            :alt="$t('ui.logo')"
          )
        
        .right-wrapper
          .d-flex.align-items-center.mr-2
            //- #themeToggle.btn-theme(v-if="brand === 'FOTBET'")
            //-   i.fas.fa-sun
            .btn-switch-device(
              v-if="!whiteLabel" 
              @click="switchToDesktop"
              :title="$t('ui.switch_to_desktop')"
            )
              img.switch-device-mobile(src='images/landing/mobile-icon.png')
              img.switch-device-desktop(src='images/landing/desktop-icon.png')
            
            .line
            
            .lang-wrap
              .lang-select2
                .btn-select(@click="toggleLanguageDropdown")
                  li
                    img(:src="'/images/lang/' + language + '.svg?v=12'")
                
                .lang-dropdown-wrap
                  ul#lang-dropdown-list
                    li(
                      v-for="item in languageList" 
                      :key="item"
                      @click="setLanguage(item)"
                    )
                      img(:src="'/images/lang/' + item + '.svg?v=12'")
                      span {{ $t("language." + item) }}
    section.slider-wrap
      .swiper.lp-banner
        .swiper-wrapper
          .swiper-slide(
            v-for="(banner, index) in bannerSlides" 
            :key="index"
          )
            img.banner-desktop(:src="banner.desktop")
            img.banner-mobile(:src="banner.mobile")
        .swiper-button-next
        .swiper-button-prev
        .swiper-pagination
    section.widget-wrap
      .container
        .mobile-login(v-if="!whiteLabel")
          .login-header {{ $t("ui.login") }}
          .login-field-wrapper
            .login-field
              .input-group
                .input-group-prepend
                  .input-group-text
                    i.far.fa-user
                input#username.form-control(
                  v-model="username" 
                  type="text" 
                  :placeholder="$t('ui.account_id')" 
                  autofocus 
                  autocomplete="off" 
                  maxlength="20"
                  @keyup.enter="login"
                )
            
            .login-field
              .input-group
                .input-group-prepend
                  .input-group-text
                    i.far.fa-unlock-alt
                input#password.form-control(
                  v-model="password" 
                  type="password" 
                  :placeholder="$t('ui.password')" 
                  autocomplete="off" 
                  maxlength="20" 
                  @keyup.enter="login"
                )
          
          .invalid-feedback(v-if="feedback.password" style="display:block") {{ feedback.password }}
          .invalid-feedback(v-if="feedback.username" style="display:block") {{ feedback.username }}
          .invalid-feedback(v-if="result" style="display:block") {{ $t("error." + result) }}
          
          SpinButton(
            :text="$t('ui.login')" 
            :loading="feedback.loading" 
            css="login-btn flex-grow-1" 
            @click="login"
          )
        .worldcup-timer.cdtimer(v-show="showTimer")
          .timer-logo
            img(src='images/landing/worldcup26.jpg' :alt="$t('ui.worldcup_timer')")
          .worldcup-timer-wrapper.flex-grow-1
            h4 {{ $t('ui.time_remaining') }}
            .counter-wrapper
              #timer(v-html="timerDisplay")
      
      .container
        .widget-content-wrapper
          .left
            .widget-box
              .widget-box-header {{ $t('ui.highlight') }}
              .widget-content
                iframe.hlighlight-iframe(
                  :src="widgetUrls.highlight" 
                  allowtransparency="true"
                  :title="$t('ui.highlight')"
                )
          
          .right
            .widget-box
              .widget-box-header {{ $t('ui.upcoming') }}
              .widget-content
                iframe.hotmatch-iframe(
                  :src="widgetUrls.upcoming" 
                  allowtransparency="true"
                  :title="$t('ui.upcoming')"
                )
            
            .widget-box.mt-4
              .widget-box-header {{ $t('ui.live_streaming') }}
              .widget-content
                iframe.livestream-iframe(
                  :src="widgetUrls.livestream" 
                  allowtransparency="true"
                  :title="$t('ui.live_streaming')"
                )
    footer.footer
      .container.footer-wrapper
        .tnc
          .d-flex.align-items-center
            h4
              img(src="/img2/landing2/18plus.png")
              | Underage Gambling
          .d-flex
            p
              | Gambling is illegal for kids under the age of 18. Every state prohibits gambling by minors. WBET will carry out age verification randomly and winnings will be forfeited if the gambler is below 18 years old.© 2004-2024 WBET. WBET is An Internationally Registered Trademark (Licensed Sports Bookmaker). All Rights Reserved.
        .row.pt-4.pb-4
          .col-8.license
            h4 License
            .d-flex.align-items-center.license-logo
              .image-wrap2
                img(src="/img2/landing2/license/01.png")
              .image-wrap2
                img(src="/img2/landing2/license/02.png")
              .image-wrap2
                img(src="/img2/landing2/license/03.png")
              .image-wrap2
                img(src="/img2/landing2/license/04.png")
              .image-wrap2
                img(src="/img2/landing2/license/05.png")
              .image-wrap2
                img(src="/img2/landing2/license/06.png")
              .image-wrap2
                img(src="/img2/landing2/license/07.png")
              .image-wrap2
                img(src="/img2/landing2/license/08.png")
          .col-4
            h4 Suggest Browser
            .d-flex.align-items-center.browser-logo
              .image-wrap2
                img(src="/img2/landing2/browser/chrome.png")
              .image-wrap2
                img(src="/img2/landing2/browser/edge.png")
              .image-wrap2
                img(src="/img2/landing2/browser/firefox.png")
              .image-wrap2
                img(src="/img2/landing2/browser/safari.png")
      .copyright
        .container © Copyright {{ currentYear }} {{ brand }} Sportsbook

</template>

<script>
import config from '@/config';
import { required } from 'vuelidate/lib/validators';
import SpinButton from '@/components/ui/SpinButton';
import { EventBus } from '@/library/_event-bus.js';
import { createRainEffect } from '@/utils/special-effects';
import { createCountdownTimer, formatTimerHTML } from '@/utils/timer';

export default {
  name: 'WBETV2Landing',
  
  components: {
    SpinButton
  },
  
  data() {
    return {
      languageList: ['en', 'cn', 'vi', 'th', 'id', 'kr', 'jp', 'tw'],
      username: '',
      password: '',
      feedback: {
        username: '',
        password: '',
        loading: false,
        timeout: null
      },
      result: '',
      showTimer: true,
      timerDisplay: '',
      countdownInterval: null,
      bannerSlides: [
        // {
        //   desktop: 'images/landing/banner/banner-worldcup.png',
        //   mobile: 'images/landing/banner/banner-worldcup-m.png'
        // },
        {
          desktop: 'images/landing/banner/banner-sport.png',
          mobile: 'images/landing/banner/banner-sport-m.png'
        },
        {
          desktop: 'images/landing/banner/banner-casino.png',
          mobile: 'images/landing/banner/banner-casino-m.png'
        },
        {
          desktop: 'images/landing/banner/banner-slot.png',
          mobile: 'images/landing/banner/banner-slot-m.png'
        },
        {
          desktop: 'images/landing/banner/banner-tournament.png',
          mobile: 'images/landing/banner/banner-tournament-m.png'
        },
        {
          desktop: 'images/landing/banner/banner-v-game.png',
          mobile: 'images/landing/banner/banner-v-game-m.png'
        }
      ]
    };
  },
  computed: {
    logoPath() {
      return config.logoPath;
    },
    logoCNYPath() {
      return config.logoCNYPath;
    },
    logoXMASPath() {
      return config.logoXMASPath;
    },
    cnyMode() {
      return config.cnyMode;
    },
    xmasMode() {
      return config.xmasMode;
    },
    wcMode() {
      return config.wcMode;
    },
    logoWCPath() {
      return config.logoWCPath;
    },
    whiteLabel() {
      return config.whiteLabel == '1';
    },
    esports2() {
      return config.esports2 == '1';
    },
    language() {
      return this.$store.getters.language;
    },
    brand() {
      return config.brand;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    desktopUrl() {
      const domain = window.location.hostname;
      return `https://${domain.replace('m.', '')}?view=desktop`;
    },
    widgetUrls() {
      const baseUrl = config.widgetUrl;
      const params = `theme=6&lang=${this.language}`;
      return {
        highlight: `${baseUrl}/highlight?${params}`,
        upcoming: `${baseUrl}/upcomingmatch?${params}`,
        livestream: `${baseUrl}/livestream?${params}`
      };
    }
  },
  watch: {
    result(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.result = '';
        }, 10000);
      }
    }
  },
  
  validations: {
    username: {
      required
    },
    password: {
      required
    }
  },
  
  beforeDestroy() {
    this.cleanup();
  },
  mounted() {
    this.initializeSwiper();
    this.initializeCountdownTimer();
    this.initializeSpecialEffects();

    if (this.brand === 'FOTBET') {
      $(document).ready(function () {
        $("#themeToggle").on("click", function () {
          const $html = $("html");
          const $icon = $("#themeToggle i");
          const $iframe = $(".hotmatch-iframe");

          const currentTheme = $html.attr("data-theme");

          if (currentTheme === "light") {
            $html.attr("data-theme", "dark");
            $icon.removeClass("fa-moon").addClass("fa-sun");

            $iframe.attr("src", "widget-2.0/upcoming-matches-color8.html");
          } else {
            $html.attr("data-theme", "light");
            $icon.removeClass("fa-sun").addClass("fa-moon");

            $iframe.attr("src", "widget-2.0/upcoming-matches.html");
          }
        });
      });
    }
  },
  methods: {
    switchToDesktop() {
      window.location = this.desktopUrl;
    },
    
    toggleLanguageDropdown() {
      $(".lang-dropdown-wrap").toggle();
    },
    
    setLanguage(lang) {
      this.$store.dispatch('layout/setLanguage', lang);
      $(".lang-dropdown-wrap").toggle();
    },
    
    resetValidation() {
      this.feedback.username = '';
      this.feedback.password = '';
    },
    
    initializeSwiper() {
      new Swiper('.lp-banner', {
        speed: 400,
        loop: true,
        autoplay: true,
        draggable: true,
        navigation: {
          nextEl: '.lp-banner .swiper-button-next',
          prevEl: '.lp-banner .swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      });
    },
    
    initializeCountdownTimer() {
      this.$nextTick(() => {
        this.countdownInterval = createCountdownTimer(
          'Jun 12, 2026 02:59:59',
          'timer',
          (timerData) => {
            const translations = {
              days: this.$t('message.days'),
              hours: this.$t('message.hours'),
              mins: this.$t('message.mins'),
              secs: this.$t('message.secs')
            };
            this.timerDisplay = formatTimerHTML(timerData, translations);
          },
          () => {
            this.showTimer = false;
          }
        );
      });
    },
    
    initializeSpecialEffects() {
      this.$nextTick(() => {
        if (['WBET', 'FOTBET'].includes(this.brand) && (this.cnyMode || this.xmasMode)) {
          const effectType = this.cnyMode ? 'cny' : 'xmas';
          createRainEffect(effectType);
        }
      });
    },
    
    cleanup() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      if (this.feedback.timeout) {
        clearTimeout(this.feedback.timeout);
      }
    },
    async login() {
      this.$v.$touch();
      clearTimeout(this.feedback.timeout);
      
      if (this.$v.$invalid) {
        this.handleValidationErrors();
        return;
      }
      
      try {
        this.feedback.loading = true;
        this.resetValidation();
        this.$store.dispatch('layout/reset');
        
        const loginResult = await this.$store.dispatch('user/doLogin', {
          username: this.username,
          password: this.password
        });
        
        if (loginResult.success) {
          await this.handleSuccessfulLogin();
        } else {
          this.result = loginResult.status;
        }
      } catch (error) {
        this.result = error.status || 'loginError';
      } finally {
        this.feedback.loading = false;
        this.setupErrorTimeout();
      }
    },
    
    async handleSuccessfulLogin() {
      try {
        this.feedback.loading = true;
        const balanceResult = await this.$store.dispatch('user/getBalance');
        
        if (balanceResult.success) {
          this.$store.dispatch('layout/setRadarId', null);
          EventBus.$emit('INVALIDATE');
          
          setTimeout(() => {
            this.redirectAfterLogin();
          }, 500);
        } else {
          this.result = balanceResult.status;
        }
      } catch (error) {
        this.result = error.status || 'balanceError';
      } finally {
        this.feedback.loading = false;
      }
    },
    
    redirectAfterLogin() {
      const isMMO = this.$store.getters.mmoMode;
      const hostname = window.location.hostname;
      
      if (['localhost', 'gsportm.joyful88.com'].includes(hostname)) {
        this.$router.push('/lobby');
      } else if (isMMO) {
        const domain = hostname;
        const accountId = this.$store.getters.accountId;
        const sessionToken = this.$store.getters.sessionToken;
        window.location.href = `https://${domain.replace('m.', '')}?&u=${accountId}&st=${sessionToken}`;
      } else {
        this.$router.push('/lobby');
      }
    },
    
    handleValidationErrors() {
      this.feedback.loading = false;
      this.resetValidation();
      
      if (!this.$v.username.required) {
        this.feedback.username = this.$t('error.usernameRequired');
      }
      
      if (!this.$v.password.required) {
        this.feedback.password = this.$t('error.passwordRequired');
      }
      
      this.setupErrorTimeout();
    },
    
    setupErrorTimeout() {
      this.feedback.timeout = setTimeout(() => {
        this.$v.$reset();
        this.resetValidation();
      }, 10000);
    }
  }
}
</script>
